import type { ReactNode } from 'react';

/**
 * Fixed-size column for OAuth brand marks so stacked Microsoft / Google buttons
 * align (icon + label start at the same horizontal positions).
 */
export function OauthBrandIconSlot({ children }: { children: ReactNode }) {
  return (
    <span className="flex size-5 shrink-0 items-center justify-center">
      {children}
    </span>
  );
}

export function MicrosoftLogoMark(props: React.ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 23 23" aria-hidden className="size-4" {...props}>
      <path fill="#f3f3f3" d="M0 0h23v23H0z" />
      <path fill="#f35325" d="M1 1h10v10H1z" />
      <path fill="#81bc06" d="M12 1h10v10H12z" />
      <path fill="#05a6f0" d="M1 12h10v10H1z" />
      <path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>
  );
}

export function GoogleLogoMark(props: React.ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="size-4" {...props}>
      <path
        d="M21.805 12.23c0-.678-.061-1.329-.174-1.953H12v3.695h5.498a4.705 4.705 0 0 1-2.041 3.088v2.564h3.3c1.93-1.777 3.048-4.398 3.048-7.394Z"
        fill="#4285F4"
      />
      <path
        d="M12 22c2.76 0 5.074-.915 6.766-2.476l-3.3-2.564c-.915.613-2.084.975-3.466.975-2.66 0-4.914-1.796-5.72-4.212H2.867v2.646A9.996 9.996 0 0 0 12 22Z"
        fill="#34A853"
      />
      <path
        d="M6.28 13.723A5.997 5.997 0 0 1 5.96 12c0-.598.103-1.177.32-1.723V7.631H2.867A9.996 9.996 0 0 0 2 12c0 1.611.385 3.137 1.067 4.369l3.213-2.646Z"
        fill="#FBBC05"
      />
      <path
        d="M12 6.065c1.5 0 2.847.516 3.908 1.53l2.931-2.93C17.07 2.98 14.756 2 12 2A9.996 9.996 0 0 0 2.867 7.631L6.28 10.277c.806-2.416 3.06-4.212 5.72-4.212Z"
        fill="#EA4335"
      />
    </svg>
  );
}
